import { DispCodelistenWerteResponse } from '@/types/service-response'

export class AddressDispCode {
  public constructor (
    readonly wertId: number,
    readonly bezeichnung: string
  ) {}

  static createFromResponse (responseData: DispCodelistenWerteResponse[]): Array<AddressDispCode> {
    return responseData.map((item: DispCodelistenWerteResponse ) => {
      return new AddressDispCode(
        item.WertID,
        item.Bezeichnung
      )
    })
  }
}
